import React from 'react';
import ReactSelect from 'react-select';
import styles from './selectStyles';

const Select = props => <ReactSelect {...props} styles={styles} menuPortalTarget={document.body} />;

export default Select;
